import ExamenParaModal from '../examen-para-modal'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import { convertDateToDdMmYyyy } from '@/function/function.js';
import $ from 'jquery';
import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import EnteteA5 from '@/views/entete-a5';


export default {
	name: 'examen-para',
	components: {
		ExamenParaModal, EnteteBonEtFacture,
        EnteteA5,
	},
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        activeRole: String,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number
    },
	data() {
		return {
			vm_state: open_menu_state,
			is_loading: true,
			is_empty: false,

            examen_to_be_deleted: {},
            

            format_pdf: 'a5', //  A5 (si prescriptions <= 6 ) ou A4 ( si prescription > 6)
            width_pdf: '559px',
            font_size: 'font-14',
            date_resultat: '', //  Date d'enregistrement du résultat
            filename: '',

            files: [],
            sv_loading: false,
            result_to_fill: {
                demande_id: 0,
                examen_nom: '',
                result_examen: null
            },
            is_printing: false,

            is_new_bulletin: true,
            selected_bulletin: {
                bulletin_id: 0,
                ref_bon: '',
                examens: []
            },

            bulletin_to_print: {},
            info_patient: {},
            info_caissier: {},
            result_toggler: 0,
            result_preview: {},
            info_resultat: {}
		}
	},

    watch: {
        evolution_toggler() {
            this.refreshExamenPara()

            const t = this;

            $(document).bind("click", function(e) {
                let $clicked = $(e.target);
                if (!$clicked.parents().hasClass("drp-container")) {
                    if (t.vm_state != 0) {
                        t.openMenu(t.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                    }
                }
            });

            this.date_resultat = convertDateToDdMmYyyy.convertDate(new Date());

            const tm = new Date()
            this.filename = 'Bulletin Examen_'+this.patient.nom+' '+this.patient.prenoms+'_'+tm.getTime()
            this.userInfoSetter()

            this.$store.commit("SET_EXAMEN_TO_PRINT", {})
            this.$store.commit("SET_CAN_PRINT_EXAMEN", false)
        }
    },

	computed: {
        bulletin_examens() {
            return this.$store.getters["bulletin_examens"]
        },

		/**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        patient() {
            return this.$store.getters['patient'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
	},

	mounted() {
		
	},

	methods: {
        userInfoSetter() {
            this.info_patient = {
                nom_patient: this.patient.nom+' '+this.patient.prenoms,
                sexe: (this.patient.sexe_id == 1)?'H':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                num_dossier: this.patient.code,
                age: this.patient.age
            }

            this.info_caissier = {
                nom_caissier: this.userCredentials.name,
                titre: this.userCredentials.titre
            }
        },

		/**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        demandeBulletin(is_new) {
            this.is_new_bulletin = is_new

            if (is_new) {
                this.selected_bulletin = {
                    bulletin_id: 0,
                    ref_bon: '',
                    renseignement_clinique: '',
                    examens: []
                } 
            }
        },

        editBulletin(bulletin, evolution_id) {
            this.selected_bulletin = {
                evolution_id: evolution_id,
                bulletin_id: bulletin.bulletin_id,
                ref_bon: bulletin.ref_bon,
                examens: bulletin.examens,
                renseignement_clinique: bulletin.renseignement_clinique
            }
        },

		/**
		 * Rafraichir la liste de demande d'examen
		 */
		refreshExamenPara() {
			this.is_loading = true

            const data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                est_encours: true
            }

			this.$store.dispatch('getBulletinExamen', data).then(() => {
				if (this.bulletin_examens.length == 0) {
					this.is_empty = true
				} else {
					this.is_empty = false
				}
                this.is_loading = false
			})
		},


		/**
         * Medicament à supprimer
         */
        retirerExamen(examen, bulletin_id, evolution_id) {
            this.examen_to_be_deleted = {
                evolution_id: evolution_id,
                bulletin_id: bulletin_id,
				consultation_id: this.consultation.id,
                user_id: this.userCredentials.id,
                examen_id: examen.examen_id,
                libelle: examen.type_examen_nom
            }
        },

        setBulletinToRemove(bulletin) {
            this.examen_to_be_deleted = {
                bulletin_id: bulletin.bulletin_id,
                libelle: bulletin.ref_bon,
				consultation_id: this.consultation.id,
                user_id: this.userCredentials.id,
            }
        },

        successExamentDeleted: function() {
            this.$toasted.show('Examen supprimé avec succès', {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        errorExamentDeletion: function() {
            this.$toasted.show('Désolé ! L\'examen a été déjà encaissé.', {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                type: 'error'

            })
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },


        previewResultExamen(demande_examen, bulletin) {
            this.result_toggler = (this.result_toggler == 0)?1:0
            let demande = {
                type_examen_nom: demande_examen.type_examen,
                resultat: demande_examen.resultat,
                interpretation: demande_examen.interpretation
            }
            this.info_resultat = {
                age: this.patient.age,
                date_naissance: this.patient.date_naissance,
                demande_id: demande_examen.examen_id,
                etat_resultat: demande_examen.etat_resultat,
                interpretation: demande_examen.interpretation,
                patient: this.patient.nom+' '+this.patient.prenoms,
                nom_prescripteur: demande_examen.nom_prescripteur,
                titre_prescripteur: demande_examen.titre_prescripteur,
                nom_radiologue: demande_examen.nom_radiologue,
                titre_radiologue: demande_examen.titre_radiologue,
                renseignement_clinique: bulletin.renseignement_clinique,
                resultat: demande_examen.resultat,
                sexe: (this.patient.sexe_id == 1)?'H':(this.patient.sexe_id == 2)?'F':'',
                telephone: this.patient.telephone_mobile,
                tel_pers_a_prevenir: bulletin.tel_pers_a_prevenir
            }
            this.result_preview = demande

            // setTimeout(() => {
            //     $('.view-result-examen').modal('show')
            // }, 500);
            
            const param_result = {
                result_preview: this.result_preview,
                evolution_id: this.evolution_id,
                info_resultat: this.info_resultat
            }
            this.$emit('emitViewOnGoingExamenParaResult', param_result)
        },

        handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			/*
				Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}

            this.result_to_fill.result_examen = this.files[0];
		},

        fillResult(data) {
            this.result_to_fill = {
                demande_id: data.examen_id,
                examen_nom: data.type_examen_nom,
                examen_commentaire: data.interpretation
            }

            $('.fill-result-exam'+this.evolution_id).modal('show')
        },

        saveResultat() {
            this.sv_loading = true

            let data = {
                demande_id: this.result_to_fill.demande_id,
                commentaire: this.result_to_fill.examen_commentaire,
                result_examen: this.result_to_fill.result_examen
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.$store.dispatch('saveResultatExamen', form_data).then((response) => {
                if (response > 0) {
                    this.refreshExamenPara()
                    this.successToast("Résultat enregistré avec succès")

                    $('.modal').modal('hide')
                    this.files = []
                    this.sv_loading = false
                } else {
                    this.errorMsg('Une erreur est survenue! Merci de réessayer.')
                }
            })
        },

        errorMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-danger',
                type: 'danger',
                position: 'top-center'

            })
        },

        printBulletinExamen(bulletin) {
            this.$store.commit("SET_EXAMEN_TO_PRINT", bulletin)
            this.$store.commit("SET_CAN_PRINT_EXAMEN", true)
        }
	}
}


